import { array, object } from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, NavLink } from 'react-router-dom';
import { Language, Search } from '../Components/Layout';
import Logo from '../Images/logo.svg';
import Notifications from '../Images/notification.svg';
import LogoP from '../Images/p-logo.svg';
import { Header, Section } from './Styled';
const Layout = ({ children }) => {
	const { t } = useTranslation('translation', { keyPrefix: 'app' });
	return (
		<>
			<Header>
				<div className='left'>
					<img src={Logo} alt='prep-logo' />
					<img src={LogoP} alt='prep-logo' />
				</div>
				<div className='right'>
					<div className='search'>
						<Search />
					</div>
					<div className='notifications'>
						<Link to='/notifications'>
							<img src={Notifications} alt='teacher-notifications' />
							<span>2</span>
						</Link>
					</div>
					<div className='language'>
						<Language />
					</div>
				</div>
			</Header>
			<Section>
				<aside>
					<ul>
						<li>
							<NavLink
								activeClassName='active'
								data-title={t('my-profile')}
								to='/profile'>
								<svg viewBox='0 0 24 24' fill='none' className='svg'>
									<path
										clipRule='evenodd'
										d='M11.9849 15.3462C8.11731 15.3462 4.81445 15.931 4.81445 18.2729C4.81445 20.6148 8.09636 21.2205 11.9849 21.2205C15.8525 21.2205 19.1545 20.6348 19.1545 18.2938C19.1545 15.9529 15.8735 15.3462 11.9849 15.3462Z'
										fillRule='evenodd'
										strokeLinecap='round'
										strokeLinejoin='round'
										strokeWidth='2'
									/>
									<path
										clipRule='evenodd'
										d='M11.9849 12.0059C14.523 12.0059 16.5801 9.94779 16.5801 7.40969C16.5801 4.8716 14.523 2.81445 11.9849 2.81445C9.44679 2.81445 7.3887 4.8716 7.3887 7.40969C7.38013 9.93922 9.42394 11.9973 11.9525 12.0059H11.9849Z'
										fillRule='evenodd'
										strokeLinecap='round'
										strokeLinejoin='round'
										strokeWidth='2'
									/>
								</svg>
								<span>{t('my-profile')}</span>
							</NavLink>
						</li>
						<li>
							<NavLink
								activeClassName='active'
								data-title={t('courses')}
								to='/courses'>
								<svg viewBox='0 0 24 24' fill='none' className='svg'>
									<path
										clipRule='evenodd'
										d='M21.419 15.7321C21.419 19.3101 19.31 21.4191 15.732 21.4191H7.95C4.363 21.4191 2.25 19.3101 2.25 15.7321V7.93212C2.25 4.35912 3.564 2.25012 7.143 2.25012H9.143C9.861 2.25112 10.537 2.58812 10.967 3.16312L11.88 4.37712C12.312 4.95112 12.988 5.28912 13.706 5.29012H16.536C20.123 5.29012 21.447 7.11612 21.447 10.7671L21.419 15.7321Z'
										fillRule='evenodd'
										strokeLinecap='round'
										strokeLinejoin='round'
										strokeWidth='2'
									/>
									<path
										d='M7.48047 14.463H16.2155'
										strokeLinecap='round'
										strokeLinejoin='round'
										strokeWidth='2'
									/>
								</svg>
								<span>{t('courses')}</span>
							</NavLink>
						</li>
						<li>
							<NavLink
								activeClassName='active'
								data-title={t('statistics')}
								to='/statistics'>
								<svg viewBox='0 0 24 24' fill='none' className='svg'>
									<path
										d='M7.24414 14.7815L10.2373 10.8913L13.6515 13.5732L16.5805 9.79291'
										strokeLinecap='round'
										strokeLinejoin='round'
										strokeWidth='2'
									/>
									<circle
										cx='19.9945'
										cy='4.20021'
										r='1.9222'
										strokeLinecap='round'
										strokeLinejoin='round'
										strokeWidth='2'
									/>
									<path
										d='M14.9238 3.12012H7.65606C4.64462 3.12012 2.77734 5.25284 2.77734 8.26428V16.3467C2.77734 19.3581 4.60801 21.4817 7.65606 21.4817H16.2602C19.2716 21.4817 21.1389 19.3581 21.1389 16.3467V9.30776'
										strokeLinecap='round'
										strokeLinejoin='round'
										strokeWidth='2'
									/>
								</svg>
								<span>{t('statistics')}</span>
							</NavLink>
						</li>
						<li>
							<NavLink
								activeClassName='active'
								data-title={t('settings')}
								to='/notifications'>
								<svg viewBox='0 0 24 24' className='notifications'>
									<path d='M17.625 13.9273V10.8192C17.6237 9.43431 17.1523 8.09464 16.2943 7.0374C15.4364 5.98015 14.2472 5.27356 12.9375 5.04275V3.97739C12.9375 3.71817 12.8387 3.46957 12.6629 3.28627C12.4871 3.10298 12.2486 3 12 3C11.7514 3 11.5129 3.10298 11.3371 3.28627C11.1613 3.46957 11.0625 3.71817 11.0625 3.97739V5.04275C9.75276 5.27356 8.56362 5.98015 7.70567 7.0374C6.84773 8.09464 6.37635 9.43431 6.375 10.8192V13.9273C5.82792 14.1289 5.35406 14.502 5.01838 14.9955C4.6827 15.489 4.50163 16.0786 4.5 16.6835V18.6383C4.5 18.8975 4.59877 19.1461 4.77459 19.3294C4.9504 19.5127 5.18886 19.6157 5.4375 19.6157H8.38125C8.59714 20.4439 9.06844 21.1751 9.72243 21.6963C10.3764 22.2176 11.1768 22.5 12 22.5C12.8232 22.5 13.6236 22.2176 14.2776 21.6963C14.9316 21.1751 15.4029 20.4439 15.6187 19.6157H18.5625C18.8111 19.6157 19.0496 19.5127 19.2254 19.3294C19.4012 19.1461 19.5 18.8975 19.5 18.6383V16.6835C19.4984 16.0786 19.3173 15.489 18.9816 14.9955C18.6459 14.502 18.1721 14.1289 17.625 13.9273ZM8.25 10.8192C8.25 9.78227 8.64509 8.78786 9.34835 8.05467C10.0516 7.32148 11.0054 6.90958 12 6.90958C12.9946 6.90958 13.9484 7.32148 14.6517 8.05467C15.3549 8.78786 15.75 9.78227 15.75 10.8192V13.7513V15.7061H16.6875H17.1562L17.3504 15.9924L17.625 16.1948V16.6835V17.6609H6.375V16.6835V16.1948L6.64959 15.9924L6.84375 15.7061H7.3125H8.25V10.8192ZM12 20.5931C11.6728 20.591 11.3518 20.4997 11.0689 20.3283C10.786 20.1568 10.5511 19.9111 10.3875 19.6157H13.6125C13.4489 19.9111 13.214 20.1568 12.9311 20.3283C12.6482 20.4997 12.3272 20.591 12 20.5931ZM17.625 17.6609H6.375V16.6835C6.375 16.4243 6.47377 16.1757 6.64959 15.9924C6.8254 15.8091 7.06386 15.7061 7.3125 15.7061H6.84375L6.64959 15.9924L6.375 16.1948V16.6835V17.6609H17.625V16.6835V16.1948L17.3504 15.9924L17.1562 15.7061H16.6875C16.9361 15.7061 17.1746 15.8091 17.3504 15.9924C17.5262 16.1757 17.625 16.4243 17.625 16.6835V17.6609Z' />
								</svg>
								<span>{t('notifications')}</span>
							</NavLink>
						</li>
						<li>
							<NavLink
								activeClassName='active'
								data-title={t('settings')}
								to='/settings'>
								<svg viewBox='0 0 24 24' className='settings'>
									<path d='M19.8999 12.66C19.7396 12.4775 19.6512 12.2429 19.6512 12C19.6512 11.7571 19.7396 11.5225 19.8999 11.34L21.1799 9.90002C21.3209 9.74269 21.4085 9.54472 21.4301 9.33452C21.4516 9.12433 21.4061 8.9127 21.2999 8.73002L19.2999 5.27002C19.1948 5.08754 19.0348 4.94289 18.8426 4.8567C18.6505 4.77051 18.4361 4.74718 18.2299 4.79002L16.3499 5.17002C16.1107 5.21945 15.8616 5.17961 15.6498 5.05802C15.4379 4.93643 15.2779 4.7415 15.1999 4.51002L14.5899 2.68002C14.5228 2.4814 14.395 2.30888 14.2245 2.18686C14.0541 2.06484 13.8495 1.99948 13.6399 2.00002H9.6399C9.42183 1.98864 9.20603 2.04894 9.02546 2.17173C8.84489 2.29452 8.70948 2.47304 8.6399 2.68002L8.0799 4.51002C8.0019 4.7415 7.84187 4.93643 7.63001 5.05802C7.41815 5.17961 7.16911 5.21945 6.9299 5.17002L4.9999 4.79002C4.80445 4.7624 4.6052 4.79324 4.42724 4.87866C4.24929 4.96407 4.1006 5.10025 3.9999 5.27002L1.9999 8.73002C1.89106 8.91067 1.84212 9.1211 1.86008 9.33124C1.87804 9.54138 1.96198 9.74046 2.0999 9.90002L3.3699 11.34C3.53022 11.5225 3.61863 11.7571 3.61863 12C3.61863 12.2429 3.53022 12.4775 3.3699 12.66L2.0999 14.1C1.96198 14.2596 1.87804 14.4587 1.86008 14.6688C1.84212 14.8789 1.89106 15.0894 1.9999 15.27L3.9999 18.73C4.10499 18.9125 4.26502 19.0571 4.45715 19.1433C4.64928 19.2295 4.86372 19.2529 5.0699 19.21L6.9499 18.83C7.18911 18.7806 7.43815 18.8204 7.65001 18.942C7.86187 19.0636 8.0219 19.2585 8.0999 19.49L8.7099 21.32C8.77948 21.527 8.91489 21.7055 9.09546 21.8283C9.27603 21.9511 9.49183 22.0114 9.7099 22H13.7099C13.9195 22.0006 14.1241 21.9352 14.2945 21.8132C14.465 21.6912 14.5928 21.5186 14.6599 21.32L15.2699 19.49C15.3479 19.2585 15.5079 19.0636 15.7198 18.942C15.9316 18.8204 16.1807 18.7806 16.4199 18.83L18.2999 19.21C18.5061 19.2529 18.7205 19.2295 18.9126 19.1433C19.1048 19.0571 19.2648 18.9125 19.3699 18.73L21.3699 15.27C21.4761 15.0873 21.5216 14.8757 21.5001 14.6655C21.4785 14.4553 21.3909 14.2573 21.2499 14.1L19.8999 12.66ZM18.4099 14L19.2099 14.9L17.9299 17.12L16.7499 16.88C16.0297 16.7328 15.2805 16.8551 14.6445 17.2238C14.0085 17.5925 13.53 18.1819 13.2999 18.88L12.9199 20H10.3599L9.9999 18.86C9.76975 18.1619 9.29128 17.5725 8.6553 17.2038C8.01932 16.8351 7.27012 16.7128 6.5499 16.86L5.3699 17.1L4.0699 14.89L4.8699 13.99C5.36185 13.44 5.63383 12.7279 5.63383 11.99C5.63383 11.2521 5.36185 10.54 4.8699 9.99002L4.0699 9.09002L5.3499 6.89002L6.5299 7.13002C7.25012 7.27724 7.99932 7.1549 8.6353 6.78622C9.27128 6.41753 9.74975 5.82818 9.9799 5.13002L10.3599 4.00002H12.9199L13.2999 5.14002C13.53 5.83818 14.0085 6.42753 14.6445 6.79622C15.2805 7.1649 16.0297 7.28724 16.7499 7.14002L17.9299 6.90002L19.2099 9.12002L18.4099 10.02C17.9235 10.5688 17.6549 11.2767 17.6549 12.01C17.6549 12.7433 17.9235 13.4513 18.4099 14ZM11.6399 8.00002C10.8488 8.00002 10.0754 8.23461 9.41761 8.67414C8.75982 9.11366 8.24713 9.73838 7.94438 10.4693C7.64163 11.2002 7.56241 12.0045 7.71675 12.7804C7.8711 13.5563 8.25206 14.269 8.81147 14.8284C9.37088 15.3879 10.0836 15.7688 10.8595 15.9232C11.6355 16.0775 12.4397 15.9983 13.1706 15.6955C13.9015 15.3928 14.5262 14.8801 14.9658 14.2223C15.4053 13.5645 15.6399 12.7911 15.6399 12C15.6399 10.9392 15.2185 9.92174 14.4683 9.17159C13.7182 8.42144 12.7008 8.00002 11.6399 8.00002ZM11.6399 14C11.2443 14 10.8577 13.8827 10.5288 13.663C10.1999 13.4432 9.94351 13.1308 9.79214 12.7654C9.64076 12.3999 9.60116 11.9978 9.67833 11.6098C9.7555 11.2219 9.94598 10.8655 10.2257 10.5858C10.5054 10.3061 10.8618 10.1156 11.2497 10.0384C11.6377 9.96128 12.0398 10.0009 12.4053 10.1523C12.7707 10.3036 13.0831 10.56 13.3028 10.8889C13.5226 11.2178 13.6399 11.6045 13.6399 12C13.6399 12.5304 13.4292 13.0392 13.0541 13.4142C12.679 13.7893 12.1703 14 11.6399 14Z' />
								</svg>
								<span>{t('settings')}</span>
							</NavLink>
						</li>
					</ul>
				</aside>
				<main>
					<section>{children}</section>
					<footer>
						<h4>
							Prep.uz © {new Date().getFullYear()}. {t('copy-right')}
						</h4>
					</footer>
				</main>
			</Section>
		</>
	);
};
Layout.propTypes = {
	children: object || array,
};
export default Layout;
